/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {  ICianApiSiteV1GetRegionCitiesRequest,  TCianApiSiteV1GetRegionCitiesModel,  IMappers,  TCianApiSiteV1GetRegionCitiesResponse } from './types'
import type {  IHttpApi,  IHttpApiFetchConfig,  FetchResponse } from '@cian/http-api'
import type {  IGetRegionCitiesResponseSchema31 } from '../../../../entities/schemas/GetRegionCitiesResponseSchema31'
import type {  IErrorResponseSchema32 } from '../../../../entities/schemas/ErrorResponseSchema32'


export function createCianApiSiteV1GetRegionCitiesModel(parameters: ICianApiSiteV1GetRegionCitiesRequest): TCianApiSiteV1GetRegionCitiesModel {
return {
v: 1,apiType: 'legacy',method: 'GET',microserviceName: 'monolith-python',pathApi: '/cian-api/site/v1/get-region-cities/',response: {
200: {
contentType: 'json',
},400: {
contentType: 'json',
},
},request: {
parameters,

},
};
}


export interface ICianApiSiteV1GetRegionCitiesOptions<TResponse200, TResponse400>  {
httpApi: IHttpApi;
config?: IHttpApiFetchConfig;
mappers?: IMappers<TResponse200, TResponse400>;
parameters: ICianApiSiteV1GetRegionCitiesRequest;

}

export async function fetchCianApiSiteV1GetRegionCities<TResponse200, TResponse400>({
httpApi,
config,
mappers,
parameters,

}: ICianApiSiteV1GetRegionCitiesOptions<TResponse200, TResponse400>): Promise<FetchResponse<TCianApiSiteV1GetRegionCitiesResponse> | TResponse200 | TResponse400> {
const {
statusCode,
response,
headers,

} = (await httpApi.fetch(createCianApiSiteV1GetRegionCitiesModel(parameters), config)) as FetchResponse<TCianApiSiteV1GetRegionCitiesResponse>;
if (mappers && statusCode in mappers) {
if (statusCode === 200) {
return mappers[200](response as IGetRegionCitiesResponseSchema31, headers);
}if (statusCode === 400) {
return mappers[400](response as IErrorResponseSchema32, headers);
}
}return {
statusCode,
response,
headers,

} as FetchResponse<TCianApiSiteV1GetRegionCitiesResponse>;
}

